export default "__VITE_ASSET__qsy6Pvyc__"